import { render, staticRenderFns } from "./UiDropdownItem.vue?vue&type=template&id=19c4a5ee&"
import script from "./UiDropdownItem.vue?vue&type=script&lang=js&"
export * from "./UiDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports